import React from 'react'
import { Button } from '@paintscout/ui'
import AdditionalWorkItem from './AdditionalWorkItem'
import type { PainterAdditionalWork } from './types'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'

interface AdditionalWorkSectionProps {
  items: PainterAdditionalWork[]
  showHours?: boolean
  canAddAdditionalWork: boolean
  onAdd: () => void
  onAcceptSign?: (id: string) => void
  onEdit?: (id: string) => void
  onDelete?: (id: string) => void
  onViewMedia?: (id: string) => void
  classes: ReturnType<typeof usePainterAdditionalWorkStyles>
}

export default function AdditionalWorkSection(props: AdditionalWorkSectionProps) {
  const { items, showHours, canAddAdditionalWork, onAdd, classes, onAcceptSign, onEdit, onDelete, onViewMedia } = props
  if (items.length === 0 && !canAddAdditionalWork) return null
  return (
    <div className={classes.additionalWorkSection}>
      <div className={classes.additionalWorkHeader}>
        <span className={classes.additionalWorkHeading}>Additional Work</span>
        {canAddAdditionalWork && (
          <Button className={classes.addLink} variant="textNoPadding" color="primary" onClick={onAdd}>
            + Add
          </Button>
        )}
      </div>
      {[...items]
        .sort((a, b) => (a.status === 'approved' ? 1 : 0) - (b.status === 'approved' ? 1 : 0))
        .map((item) => (
          <AdditionalWorkItem
            key={item.id}
            item={item}
            showHours={showHours}
            classes={classes}
            onAcceptSign={onAcceptSign}
            onEdit={onEdit}
            onDelete={onDelete}
            onViewMedia={onViewMedia}
          />
        ))}
    </div>
  )
}
